var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar',{attrs:{"links":_vm.links},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('Title')]},proxy:true}])}),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }